(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-kalyo-buy-now]') : null;
    if (!button) return;
    const form = button.closest('form');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1, properties: { Inclus: 'Bracelet silicone et ebook offerts' } }] }),
      });
      if (!response.ok) throw new Error('add failed');
      window.location.href = `${root}checkout`;
    } catch (error) {
      button.disabled = false;
      window.location.href = `${root}cart`;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
